export default class Subtask {
  constructor({
    id = null,
    title = '',
    description = '',
    number = null,
    updated_at = null,
    to_evaluate = null,
    resource_file_paths = [],
    submission_file_paths = [],
    test_file_paths = [],
    test_pre_check_file_paths = [],
    homework_id = null,
    homework_title = null,
    resource_files_metadata = null,
    submission_files_metadata = null,
    test_files_metadata = null,
    test_pre_check_files_metadata = null,
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.number = number;
    this.updated_at = updated_at;
    this.to_evaluate = to_evaluate;
    this.resource_file_paths = resource_file_paths;
    this.submission_file_paths = submission_file_paths;
    this.test_file_paths = test_file_paths;
    this.test_pre_check_file_paths = test_pre_check_file_paths;
    this.homework_id = homework_id;
    this.homework_title = homework_title;
    this.resource_files_metadata = resource_files_metadata;
    this.submission_files_metadata = submission_files_metadata;
    this.test_files_metadata = test_files_metadata;
    this.test_pre_check_files_metadata = test_pre_check_files_metadata;
  }

  // Basic validation for subtask data
  static validate(subtaskData) {
    if (!subtaskData.title) {
      throw new Error('Title is required');
    }
    if (!subtaskData.homework_id || isNaN(subtaskData.homework_id)) {
      throw new Error('Homework ID is required and must be a number');
    }
    if (!subtaskData.number || isNaN(subtaskData.number)) {
      throw new Error('Number is required');
    }
    if (subtaskData.to_evaluate == null) {
      throw new Error('To evaluate cannot be null');
    }
  }

  // Format date to DD.MM.YYYY HH:MM
  static formatDate(date) {
    if (typeof date !== 'string') {
        if (date instanceof Date && !isNaN(date)) {
            date = date.toISOString();
        } else {
            try {
                date = new Date(date).toISOString();
            } catch (e) {
                console.error('Invalid date:', date);
                return '';
            }
        }
    }
    if (!date) return '';

    const [datePart, timePart] = date.split('T');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':').map(part => part.split('.')[0]);

    return `${day}.${month}.${year} ${hour}:${minute}`;
  }

  // converts bytes to human-readable units
  static formatFileSize(bytes) {
    if (bytes === 0 || bytes == null) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
    return `${size} ${sizes[i]}`;
  }

  // Format date to DD.MM.YYYY HH:MM and consider timezone if provided
  static formatDateTimeZone(date) {
    let dateObj;
    if (typeof date === 'number' || (typeof date === 'string' && !isNaN(Number(date)))) {
      dateObj = new Date(Number(date) * 1000);
    } else if (typeof date === 'string') {
      dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        console.error('Invalid date:', date);
        return '';
      }
    } else if (date instanceof Date) {
      dateObj = date;
      if (isNaN(dateObj.getTime())) {
        return '';
      }
    } else {
      try {
        dateObj = new Date(date);
      } catch (e) {
        console.error('Invalid date:', date);
        return '';
      }
    }

    // Convert to local time
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    const hour = String(dateObj.getHours()).padStart(2, '0');
    const minute = String(dateObj.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hour}:${minute}`;
  }
}

export class SubtaskWithStudentSubmissions extends Subtask {
  constructor({
    submissions = [],
    ...subtaskData
  }) {
    super(subtaskData);
    this.student_submissions = submissions;
  }
}